module.exports = __webpack_public_path__ + "img/04-min.b8dc02ea.jpg";